import { render, staticRenderFns } from "./transAcctT.vue?vue&type=template&id=6d5f1258&scoped=true&"
import script from "./transAcctT.vue?vue&type=script&lang=js&"
export * from "./transAcctT.vue?vue&type=script&lang=js&"
import style0 from "./transAcctT.vue?vue&type=style&index=0&id=6d5f1258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5f1258",
  null
  
)

export default component.exports